// Typelizer digest d35a8a2f82660332419b37f141da36f9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /.well-known/apple-app-site-association */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/.well-known/apple-app-site-association', {}, options),
    method: 'get',
  }),
}
